export default "__VITE_ASSET__lZVGFb3o__"